export default "__VITE_ASSET__80904728__"